export enum FeatureFlagName {
  STONLY_KB = 'STONLY_KB',
  VONAGE_WHATSAPP_SERVICE = 'VONAGE_WHATSAPP_SERVICE',
  ENGAGE_ATTACHMENT = 'ENGAGE_ATTACHMENT',
  AI_SUMMARIZE = 'AI_SUMMARIZE',
  KEYCLOAK_AUTHENTICATION_DELEGATION = 'KEYCLOAK_AUTHENTICATION_DELEGATION',
  CREDIT_CARD_SANITIZATION = 'CREDIT_CARD_SANITIZATION',
}
